import { deleteProductImageId, deleteFromPluginUploads, postImageInPluginUpload } from '../common/apis'
import { RATING_TYPES } from '../common/utils'

export function filterFactoryList(filter: string, factoryList: FactoryWithCountryData[]): FactoryWithCountryData[] {
    return factoryList.filter(factory => {
        if (factory.factoryName.toLowerCase().includes(filter)) {
            return true
        } else if (factory.countryName.toLowerCase().includes(filter)) {
            return true
        } else if (
            factory.lines
                .map(line => (line.lineName.toLowerCase().includes(filter) ? line.lineName : null))
                .filter(line => line).length
        ) {
            return true
        }
    })
}
export function filterProductList(filter: string, productList: ProductData[]): ProductData[] {
    return productList.filter(product => {
        if (product.productName.toLowerCase().includes(filter)) {
            return true
        } else if (
            product.SKUs.map(sku => (sku.skuName.toLowerCase().includes(filter) ? sku.skuName : null)).filter(
                sku => sku
            ).length
        ) {
            return true
        }
    })
}

export function getLineConfigSaveDisabledStatus(lineRequestParams: FactoryParam & { line: LineData }): boolean {
    const { country, factory, line } = lineRequestParams
    const { lineName, operators, products, technology, activeAnalysis, deviations } = line
    const primaryOperators = operators.reduce((acc, operator) => {
        if (operator?.operatorType === 'primary') acc += 1

        return acc
    }, 0)

    const productsWithConfiguredSkus = products.filter(product => product.skus.length)
    const validDeviations = deviations ? isActiveAnalysisAndDeviationsValid(activeAnalysis, deviations) : true

    if (
        !country ||
        !factory ||
        !lineName ||
        !technology ||
        primaryOperators !== 1 ||
        !productsWithConfiguredSkus.length ||
        !validDeviations
    ) {
        return true
    } else {
        return false
    }
}

export function isActiveAnalysisAndDeviationsValid(activeAnalysis: ActiveAnalysis, deviations: Deviations): boolean {
    for (const rating of RATING_TYPES) {
        const validDeviations = deviations[rating].filter(devaition => {
            return devaition.trim() !== ''
        })
        if (activeAnalysis[rating] === true && !validDeviations.length) {
            return false
        }
    }

    return true
}

export function getLineRequestParams(
    country: string,
    factory: string,
    lineOperators: LineOperators[],
    lineProducts: LineProducts[],
    lineName: string,
    line: string,
    technology: string,
    activeAnalysis: ActiveAnalysis,
    deviations: Deviations
): FactoryParam & { line: LineData } {
    const validOperators = lineOperators.filter(operator => !!operator.userData && !!operator.operatorType)
    const newName = line ? lineName : line
    const newLineData = {
        country,
        factory,
        line: {
            lineName: line || lineName,
            newName,
            products: lineProducts,
            operators: validOperators,
            technology,
            activeAnalysis,
            deviations
        }
    }

    return newLineData
}

export function getNamesFromTableArray(tableArray: string[][]): string[] {
    return tableArray.map(tableRow => tableRow[0]).filter(cellName => !!cellName)
}

export function getLinesPostJson(tableDataArray: string[][], country: string, factory: string): LineParam[] {
    const jsonWithLinesInfo = tableDataArray.reduce((acc: LineParam[], lineRow) => {
        if (lineRow[0]) acc.push({ country, factory, line: lineRow[0]?.trim() })

        return acc
    }, [])

    return jsonWithLinesInfo
}

export function handleImageEdit(
    imageFile: FileType,
    currentProductImageId: string,
    productName: string
): Promise<string> {
    if (imageFile.name && currentProductImageId) {
        return removeImage(productName, currentProductImageId).then(() => postImage(imageFile))
    } else if (imageFile.removeFile) {
        return removeImage(productName, currentProductImageId).then(() => '')
    } else if (imageFile.name && !currentProductImageId) {
        return postImage(imageFile)
    }
}

export function removeImage(productName: string, imageId: string): Promise<void | Response> {
    return deleteProductImageId(productName).then(response => {
        if (response && response?.ok) {
            deleteFromPluginUploads(imageId)
        }
    })
}

export function postImage(imageFile: FileType): Promise<string> {
    const imagePostBody = getImagePostBody(imageFile)

    return postImageInPluginUpload(imagePostBody).then(body => {
        if (body) {
            return body?.uuid
        }

        return ''
    })
}

export function getImagePostBody(imageFile: FileType): FormData {
    const formData = new FormData()
    formData.append('file', imageFile as string)
    formData.append('name', imageFile?.name)
    formData.append('type', imageFile?.type)
    formData.append('username', window.Live.authorization.user.username)

    return formData
}

export function getSkusPostJson(tableDataArray: string[][], productName: string): SkuParam[] {
    const jsonWithSkuInfo = tableDataArray.reduce((acc: SkuParam[], skuRow) => {
        if (skuRow[0] || skuRow[1]) acc.push({ skuName: skuRow[0]?.trim(), productName, skuId: skuRow[1]?.trim() })

        return acc
    }, [])

    return jsonWithSkuInfo
}

export function getFaildResponse(response1: Response, response2: Response): Response {
    if (response1.status !== 200) return response1
    if (response2.status !== 200) return response2

    return response1
}
